export const PostsTableColumns = [
    {
        id: "featured_image",
        labelEn: "Image",
        labelAr: "الصورة",
        align: "center",
        sortable: false,
    },
    {
        id: "titleEn",
        labelEn: "Title (EN)",
        labelAr: "العنوان (EN)",
        align: "left",
        sortable: true,
    },
    {
        id: "titleAr",
        labelEn: "Title (AR)",
        labelAr: "العنوان (AR)",
        align: "right",
        sortable: true,
    },
    {
        id: "category",
        labelEn: "Category",
        labelAr: "التصنيف",
        align: "center",
        sortable: true,
    },
    {
        id: "status",
        labelEn: "Status",
        labelAr: "الحالة",
        align: "center",
        sortable: true,
    },
    {
        id: "created_at",
        labelEn: "Created At",
        labelAr: "تاريخ الإنشاء",
        align: "center",
        sortable: true,
    },
];
